import React from 'react'
import FormTitle from '../../../../components/FormTitle'
import Input from '../../../../components/FormInputs';
interface BankDetailsProps {
    register: any;
    errors: any;
    setValue: any;
}
const BankDetails:React.FC<BankDetailsProps> = ({register,errors,setValue}) => {
  return (
    <div className="bg-white p-4 rounded-[20px] mt-2">
        <FormTitle title="Bank Details" />
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-1">
            <Input
                label="Account Holder Name"
                name="bankDetails.accountHolderName"
                errors={errors}
                register={register}
                placeholder="Enter account holder name"
                type="text"
            />
            <Input
                label="Account Number"
                name="bankDetails.accountNumber"
                errors={errors}
                register={register}
                placeholder="Enter account number"
                type="text"
            />
            <Input
                label="IFSC Code"
                name="bankDetails.ifscCode"
                errors={errors}
                register={register}
                placeholder="Enter IFSC code"
                type="text"
            />
            <Input
                label="Bank Name"
                name="bankDetails.bankName"
                errors={errors}
                register={register}
                placeholder="Enter bank name"
                type="text"
            />
            <Input
                label="Branch Name"
                name="bankDetails.branchName"
                errors={errors}
                register={register}
                placeholder="Enter branch name"
                type="text"
            />
            <Input
                label="UPI ID"
                name="bankDetails.upiId"
                errors={errors}
                register={register}
                placeholder="Enter UPI ID"
                type="text"
            />
            <Input
                label="UPI Number"
                name="bankDetails.upiNumber"
                errors={errors}
                register={register}
                placeholder="Enter UPI Number"
                type="text"
            />

            
        </div>
    </div>    
       
  )
}

export default BankDetails